<style lang="less">
  .deleted{
    width: 375px;height: 700px;
    margin: auto;
    margin-top: 20px;
    border: 1px solid #d8d8d8;
    text-align: center;
    font-size: 18px;
    padding:200px 50px; 
  }
  .deletedM{
    width: 750px;height: 100%;
    margin-top: 400px;
    text-align: center;
    font-size: 36px;
  }
</style>
<template>
  <div :class="isMobile?'deletedM':'deleted'">
    {{pageData}}
  </div>
</template>

<script>
  export default {
    props:['pageData'],
    components:{},
    filters:{},
    data(){
      return {
        isMobile: window.browserVersion.mobile,
      }
    },
    methods:{
    },
    mounted(){
    }
  }
</script>